<script lang="ts">
	import { scrollProgressStore } from './stores/scrollProgress';

	let progress: HTMLElement | undefined = $state();

	scrollProgressStore.subscribe((value) => {
		if (progress) progress.style.width = `${value}%`;
	});
</script>

<div class="absolute top-full w-full md:hidden">
	<div class="bg-green-primary h-[2px] w-0" bind:this={progress}></div>
</div>
